import React from 'react';

export default function LoginView(): JSX.Element {
  return <>Login</>;
}
